module.exports = __webpack_public_path__ + "static/media/ic-cervical-lateral-flexion.f9421e8a.svg";